import { QRPaymentAPI } from "../api";

export class QRPayment {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }

  static async qrPaymentRequest(postData) {
    const { data } = await QRPaymentAPI.qrPaymentRequest(postData);
    return new QRPayment(data.result)
  }

  static async qrPaymentCheckStatus(id) {
    const { data } = await QRPaymentAPI.qrPaymentCheckStatus(id);
    return new QRPayment(data.result)
  }

  static async qrPaymentInquiry(id) {
    const { data } = await QRPaymentAPI.qrPaymentInquiry(id);
    return new QRPayment(data.result)
  }

  static async qrPaymentLastRequest(postData) {
    const { data } = await QRPaymentAPI.qrPaymentLastRequest(postData);
    return new QRPayment(data.result)
  }

  static async qrPaymentCancel(id) {
    const { data } = await QRPaymentAPI.qrPaymentCancel(id);
    return new QRPayment(data.result)
  }

  static async qrPaymentVoid(postData) {
    const { data } = await QRPaymentAPI.qrPaymentVoid(postData);
    return new QRPayment(data.result)
  }

  static async qrPaymentVoidWithCancelPayment(postData) {
    const { data } = await QRPaymentAPI.qrPaymentVoidWithCancelPayment(postData);
    return data.result
  }
}
